//This component is implemented to cater the cell that has unlimited data,
// including a visibility icon allowing user to click and show popup

import { ZfIcon, ZfStack } from '@zafire/react';
import { ICellRendererParams } from 'ag-grid-enterprise';

type AuditHistoryCustomCellType = ICellRendererParams & {
  onClick: (params: { title: string; data: string }) => void;
};
const AuditHistoryCustomCell = (params: AuditHistoryCustomCellType) => {
  if (params.value?.length > 30) {
    const label = params.value.substring(0, 29);
    return (
      <ZfStack
        direction="row"
        spacing="small"
        style={{ alignItems: 'center', justifyContent: 'space-between', height: '100%' }}
      >
        {/* using span instead of zfinput as ag grid is using 12px font */}
        <span style={{ fontSize: 12, overflow: 'hidden' }}>{label}...</span>
        <ZfIcon
          name="visibility"
          size="medium"
          style={{ cursor: 'pointer' }}
          onClick={() => params?.onClick({ title: params.data.attribute, data: params.value })}
        />
      </ZfStack>
    );
  }
  return params.value;
};

export default AuditHistoryCustomCell;
